module.exports = __webpack_public_path__ + "media/images/app/cover-3f3452870d5a95e0a4fef83f6f03a8fd.webp";